import { Suspense, lazy } from 'react';

const AppShell = lazy(() => import('@/AppShell'));

function App(): React.JSX.Element {
  return (
    <Suspense fallback={<div className="min-h-screen w-full bg-surface" aria-hidden />}>
      <AppShell />
    </Suspense>
  );
}

export default App;

